import { apiClient } from '@devd-client/api';
import { InvestmentCategoryResponse } from '../helpers/investment-categories.types';
import { getToken, getOrgId } from '@devd-client/devd/auth';

type AddInvestmentCategoryProps = {
  integration: string;
  category: string;
  type: string;
  sqlOperator: string;
  value: string;
  color: string;
  field: string;
};

type DeleteInvestmentCategoryProps = {
  orgId?: string;
  integration: string;
  category: string;
  type: string;
};

export const getInvestmentCategories =
  (): Promise<InvestmentCategoryResponse> =>
    apiClient(`/v2/org/${getOrgId()}/investment`, {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    });

export const addUpdateInvestmentCategories = (
  params: AddInvestmentCategoryProps
): Promise<any> =>
  apiClient(`/v2/org/${getOrgId()}/investment`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });

export const deleteInvestmentCategories = (
  params: DeleteInvestmentCategoryProps
): Promise<any> => {
  const orgId = getOrgId();
  return apiClient(`/v2/org/${getOrgId()}/investment`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ ...params, orgId }),
  });
};
